import { render, staticRenderFns } from "./event-detail-procedure.vue?vue&type=template&id=2c77869d&scoped=true&"
import script from "./event-detail-procedure.vue?vue&type=script&lang=js&"
export * from "./event-detail-procedure.vue?vue&type=script&lang=js&"
import style0 from "./event-detail-procedure.vue?vue&type=style&index=0&id=2c77869d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c77869d",
  null
  
)

export default component.exports